// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2xn9W","title":"Info_title__2GsSJ","links":"Info_links__1upY7","link":"Info_link__2YWKY","logo":"Info_logo__2gpST"};